/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_FingerprintsInputs */

const en_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fingerprints`)
};

const ar_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البصمات`)
};

const bn_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিঙ্গারপ্রিন্ট`)
};

const de_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fingerabdrücke`)
};

const es_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huellas dactilares`)
};

const fr_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empreintes digitales`)
};

const pt_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressões digitais`)
};

const zh_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指纹`)
};

const tr_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parmak izleri`)
};

const ru_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отпечатки пальцев`)
};

const pl_svchip_fingerprints = /** @type {(inputs: Svchip_FingerprintsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odciski palców`)
};

/**
* | output |
* | --- |
* | "Fingerprints" |
*
* @param {Svchip_FingerprintsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_fingerprints = /** @type {((inputs?: Svchip_FingerprintsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_FingerprintsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_fingerprints(inputs)
	if (locale === "bn") return bn_svchip_fingerprints(inputs)
	if (locale === "de") return de_svchip_fingerprints(inputs)
	if (locale === "es") return es_svchip_fingerprints(inputs)
	if (locale === "fr") return fr_svchip_fingerprints(inputs)
	if (locale === "pt") return pt_svchip_fingerprints(inputs)
	if (locale === "zh") return zh_svchip_fingerprints(inputs)
	if (locale === "tr") return tr_svchip_fingerprints(inputs)
	if (locale === "ru") return ru_svchip_fingerprints(inputs)
	if (locale === "pl") return pl_svchip_fingerprints(inputs)
	return en_svchip_fingerprints(inputs)
});